import React from "react";
import moment from "moment";
import Check from "../../Assets/approve-icon.png";
import Cross from "../../Assets/cancel-icon.png";
import "./AccordionApar.css";

const AccordionApar = ({ data, isOpen, onClick, mock }) => {
  return (
    <div className="accordion-item">
      <div
        className="accordion-title"
        onClick={onClick}
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <p style={{ margin: "6px 0" }}>
          No APAR: <b>{data.noApar}</b>
        </p>
        {data.type === "Incoming" ? (
          <p style={{ margin: "6px 0" }}>
            <b>{data.type}</b>
          </p>
        ) : (
          ""
        )}

        <p style={{ margin: "6px 0" }}>
          {data.petugas.split(" ").slice(0, 1).join(" ")}
        </p>

        <div style={{ display: "flex", alignItems: "center" }}>
          {data.type === "checksheet" ? (
            <p style={{ margin: "6px 12px 6px 0" }}>
              {moment(data.timestamp)
                .utcOffset("+0700")
                .format("DD-MM-YYYY, HH:mm:ss")}
            </p>
          ) : (
            ""
          )}
          {data.type === "Incoming" ? (
            <p style={{ margin: "6px 12px 6px 0" }}>
              {moment(data.date).utcOffset("+0700").format("DD-MM-YYYY")}
            </p>
          ) : (
            ""
          )}
          <p className="font-16-mobile" style={{ margin: "0" }}>
            <b>{isOpen ? "−" : "+"}</b>
          </p>
        </div>
      </div>
      {isOpen && (
        <div className="accordion-content" style={{ marginTop: "12px" }}>
          {data.type === "Incoming" ? (
            <p style={{ margin: "6px 0" }}>Supplier: {data.supplier}</p>
          ) : (
            ""
          )}
          <table style={{ width: "100%" }}>
            <tr>
              <th
                className="th-checksheet-apar"
                style={{ padding: "12px 6px" }}
              >
                No.
              </th>
              <th className="th-checksheet-apar">Item Check</th>
              <th className="th-checksheet-apar">Standar</th>
              <th className="th-checksheet-apar">Checklist</th>
            </tr>
            {data.type === "checksheet" &&
              mock &&
              mock.map((ele, index) => {
                const key = `q${ele.itemId}`;
                const value = data[key];
                return (
                  <tr
                    style={
                      index % 2 === 0
                        ? {
                            background: "white",
                          }
                        : {
                            background: "#f2f2f2",
                          }
                    }
                  >
                    <td
                      className="td-checksheet-apar"
                      style={{ padding: "12px 6px" }}
                    >
                      {index + 1}.
                    </td>
                    <td
                      className="td-checksheet-apar"
                      style={{ textAlign: "left" }}
                    >
                      {ele.itemCheck}
                    </td>
                    <td
                      className="td-checksheet-apar"
                      style={{ textAlign: "left", fontStyle: "italic" }}
                    >
                      {ele.standar}
                    </td>
                    {index === 12 ? (
                      <td className="td-checksheet-apar">{value}</td>
                    ) : (
                      <td className="td-checksheet-apar">
                        <div
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          {value ? (
                            <img style={{ width: "24px" }} src={Check} />
                          ) : (
                            <img style={{ width: "24px" }} src={Cross} />
                          )}
                        </div>
                      </td>
                    )}
                  </tr>
                );
              })}

            {data.type === "Incoming" &&
              data &&
              data.checklist.map((ele, index) => {
                return (
                  <tr
                    style={
                      index % 2 === 0
                        ? {
                            background: "white",
                          }
                        : {
                            background: "#f2f2f2",
                          }
                    }
                  >
                    <td
                      className="td-checksheet-apar"
                      style={{ padding: "12px 6px" }}
                    >
                      {index + 1}.
                    </td>
                    <td
                      className="td-checksheet-apar"
                      style={{ textAlign: "left" }}
                    >
                      {ele.itemCheck}
                    </td>
                    <td
                      className="td-checksheet-apar"
                      style={{ textAlign: "left", fontStyle: "italic" }}
                    >
                      {ele.standar}
                    </td>
                    {index === 7 ? (
                      <td className="td-checksheet-apar">
                        {ele.beratTabungApar} Kg
                      </td>
                    ) : index === 8 ? (
                      <td className="td-checksheet-apar">
                        {ele.beratIsiApar} Kg
                      </td>
                    ) : (
                      <td className="td-checksheet-apar">
                        <div
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          {ele.isStandard ? (
                            <img style={{ width: "24px" }} src={Check} />
                          ) : (
                            <img style={{ width: "24px" }} src={Cross} />
                          )}
                        </div>
                      </td>
                    )}
                  </tr>
                );
              })}
          </table>
        </div>
      )}
    </div>
  );
};

export default AccordionApar;
